import { gql } from "@apollo/client";

export const COUNTRY_RANKINGS_QUERY = gql`
  query GetCountryYearData($productClass: ProductClass!) {
    countryYear(productClass: $productClass) {
      countryId
      year
      eci: eciFixed
      coi
      growthProj
    }
    dataAvailability {
      productClassification
      yearMin
      yearMax
    }
    countries: locationCountry {
      countryId
      locationLevel
      iso3Code
      nameEn
      nameShortEn
      legacyCountryId
      isTrusted
      reportedServ
      reportedServRecent
      nameAbbrEn
      thePrefix
    }
    dataFlags {
      inRankings
      countryId
    }
  }
`;
